import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IASEntry } from "../models/shortage";
import { throwApiError } from "./apiError";
import { getTerminalId } from "../helpers";

/**
 * GET API call using Axios
 */

export const GetASDetailsAPI = async (osdNumber: number | string): Promise<IASEntry> => {
  try {
    // Get static headers from map
    const staticHeaders = getTrackingHeadersMap(ApiType.AS_ENTRY_DETAILS) || {};
    // Add dynamic values
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Number": osdNumber.toString(),
      "OSD-Destination-Terminal": getTerminalId(),
    };
    const response = await axios.get(`${getUrl(ApiType.AS_ENTRY_DETAILS)}/${osdNumber}`, { headers });
    return response?.data ?? {};
  } catch (error) {
    return throwApiError(error, ErrorMessages.aSEntryDetailsAPIError);
  }
};
